import Vue from 'vue'

Vue.mixin({
  data: function() {
    return {
      dateformats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['DD/MM/YYYY', 'DD-MM-YYYY','YYYY-MM-DD', 'YYYY/MM/DD'], // Only for `v-date-picker`
        dayPopover: 'L', // Only for `v-date-picker`
        data: ['L', 'DD/MM/YYYY', 'YYYY-MM-DD', 'YYYY/MM/DD'] // For attribute dates
      },
    }
  },
  methods: {
    compareDates(startDate, endDate){
      let returnValue = true;
      if(this.$moment(startDate) >= this.$moment(endDate)){
        returnValue = false;
      }
      return returnValue;
    },
    getStartOfWeek(year, weekNo) {
      return this.$moment().year(year).week(weekNo).isoWeekday(1).format('DD/MM/YYYY');
    },
    getEndOfWeek(year, weekNo) {
      return this.$moment().year(year).week(weekNo).isoWeekday(7).format('DD/MM/YYYY');
    },
    formatDate(date) {
      return this.$moment(date).format('YYYY-MM-DD')
    },
    getDates(startDate, endDate) {
      let date = []
      while(this.$moment(startDate) <= this.$moment(endDate)){
        date.push(startDate);
        startDate = this.$moment(startDate).add(1, 'days').format("YYYY-MM-DD");
      }
      return date;
     
    },
    getResponseErrorMessage(data) {
      if (data.errors != undefined) {
        let field = Object.keys(data.errors)[0]
        return data.errors[field][0]
      } else if(data.message != undefined) {
        return data.message
      } else {
        return 'Error'
      }
    }
  },
  notifications: {
    showSuccessMsg: {
      type: 'success',
      message: 'Success'
    },
    showErrorMsg: {
      type: 'error',
      message: 'Error'
    },
    showWarningMsg: {
      type: 'warn',
      message: "Warning"
    }
  }
})
